<template>
  <div class="album">
    <tip></tip>
    <template v-if="albumObj.enable">
      <empty></empty>
    </template>
    <template v-else>
      <audioTitle></audioTitle>
      <div class="conntent" v-if="!isData">
        <div class="video_btnn">
          <div class="video_count">
            共{{audioObj.rows}}条音频
          </div>

          <div class="palyall">
            <div v-if="!palyIng" @click="playAllFn">
              <img src="../../assets/img/btnbofang.png" alt="">
              <span>播放全部</span>
            </div>
            <div v-else @click="pauseFn(audioList[index])">
              <img src="../../assets/img/benzanting.png" alt="">
              <span>暂停播放</span>
            </div>
          </div>
          <div class="buylink" v-if="albumObj.buy_link" @click="toBuy(albumObj.buy_link)">
            <div >
              <span>{{ albumObj.buy_title || '购买此书' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="video-list">
        <div class="item-audio" v-for="(item, index) in audioList" :class="{ 'active': item.isActive}" :key="index">
        <span class="name">
          <span @click="topageDetail(item.id,item.view_pass)">{{item.name}}</span>
        </span>
          <span class="shichang">时长 {{lengthFnn(item.length)}} / {{lengthFnn(item.currentTime)}}</span>
          <span class="btn">
            <template v-if="item.view_pass&&!canView">
               <img   src="../../assets/img/doc-lock.png" alt="" @click.stop="playFn(item, index)">
            </template>
            <template v-else>
              <img v-if="!item.palyIng && !item.isActive" @click.stop="playFn(item, index)" src="../../assets/img/beforebofang.png" alt="">
          <img v-if="!item.palyIng && item.isActive" @click.stop="playFn(item, index)" src="../../assets/img/bofang.png" alt="">
          <img v-else @click.stop="pauseFn(item)" src="../../assets/img/zanting.png" alt="">
            </template>


        </span>
        </div>
        <div v-if="isData" class="isData">
          当前页面没有内容或内容已下架
        </div>
      </div>
      <audioBtn
          ref="audioBtn"
          :url="audioUrl"
      >
      </audioBtn>
      <Dialog
          :visible="showDialog"
          title="输入密码，解锁内容"
          @close="showDialog = false"
          @cancel="showDialog = false"
          @confirm="handleConfirm"
      />
    </template>

  </div>
</template>

<script>
import tip from '@/components/tip.vue';
import empty from '@/components/empty.vue';
import audioTitle from '@/components/audioTitle.vue';
import audioBtn from '@/components/audioBtn.vue';
import {Base64} from 'js-base64';
import { Indicator, Toast} from 'mint-ui';
import Vue from 'vue';
import Dialog from "@/components/dialog.vue";
  export default {
    components: {
      Dialog,
      tip,
      audioTitle,
      audioBtn,empty
    },
    data() {
      return {
        audioObj: {},
        audioList: [],
        albumObj: {},
        id: 0,
        iszhankai: false,
        audioUrl: '',
        palyIng: false,
        timer: null,
        index: 0,
        playAll: false,
        pageNumber: 1,
        scroll: '',
        isData: false,
        upLoading: true, // 是否加载数据
        canView:false,
        showDialog:false
      }
    },
    created () {
      this.id = this.$route.query.id || 'faf1460e-743f-4fa5-8c98-8840cdf216b8'
      this.getaudioList()
      this.report(this.id,7)
    },
    mounted () {
       document.addEventListener('scroll', this.handleScroll, true)
    },
    beforeDestroy () {
      document.removeEventListener('scroll', this.handleScroll, true)
    },
    methods: {
      toBuy(link){
        window.open(link, '_blank');
      },
      async report(id,dt) {
        try {
          // 发送点击事件请求到服务端
          await this.$report.sendReport({
            "id": id,
            "dt":dt
          });

        } catch (error) {
          console.error("Error sending click request:", error);
        }
      },
      throttle(fn, delay = 200){
       let timer = null
       return function () {
         if(timer){
           return
         }
         timer = setTimeout(() => {
           fn.apply(this, arguments)
         }, delay)
       }
      },
      handleScroll() {
       // scrollTop 滚动条滚动时，距离顶部的距离
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        // windowHeight 可视区的高度
        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        // scrollHeight 滚动条的总高度
        let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        // 滚动条到底部的条件
          
        let timer = null
        if(scrollTop + windowHeight + 150 >= scrollHeight){
          if(timer){
            return
          }
          timer = setTimeout(() => {
            console.log('进来了')
            this.loadMore()
          }, 300)
        }
      },
      loadMore(){
        if(this.upLoading) {
          this.pageNumber++
          this.getaudioList(true)
        }
      },
      // 获取单个音频
      async getAuditMp3(item){
        this.audioUrl = ''
        try {
          //const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/v1/storage/qiniu/audio/${Base64.encode(item.url)}`)
          const res = await this.axios.get(`https://api.ayerdudu.com/v1/storage/qiniu/audio/${Base64.encode(item.url)}`)
          this.audioUrl = res.data.data
          item.audioUrl = res.data.data
        } catch (err) {
          console.log(err)
        }
      },
      pauseFn(item){
        this.playAll = false
        item.palyIng = false
        this.palyIng = false
        this.$refs.audioBtn.onPause()
        clearInterval(this.timer)
        
      },
      playAllFn(){
        this.playAll = true
        this.playFn(this.audioList[0], 0)
      },
      // 播放
      async playFn(item, index){
        if(!this.canView&&item.view_pass!=""){
          this.showDialog = true;
          return;
        }
        this.index = index
        // this.audioUrl = ''
        this.palyIng = true
        // 清空其他的
        this.audioList.forEach(i =>{
          if(i !== item){
            i.palyIng = false
            i.currentTime = 0
            i.isActive = false
          }
        })
        clearInterval(this.timer)
        // 如果是已经播放过的，不需要请求，直接播放
        if(item.audioUrl){
          this.audioUrl = item.audioUrl
          item.palyIng = true
          item.isActive = true
          this.$nextTick(()=>{
            this.$refs.audioBtn.onPlay()
            this.timer = setInterval(() => {
              // 判断超时
              this.toTopFn(item, index)
            }, 1000)
          })
        }else{
          // 没有播放过，需要请求一下音频
          try {
            //const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/v1/storage/qiniu/audio/${Base64.encode(item.url)}`)
            const res = await this.axios.get(`https://api.ayerdudu.com/v1/storage/qiniu/audio/${Base64.encode(item.url)}`)
            this.audioUrl = res.data.data
            item.audioUrl = res.data.data
            item.palyIng = true
            item.isActive = true
            this.$nextTick(()=>{
              if(this.$refs.audioBtn.isOk){
                this.$refs.audioBtn.onPlay()
                this.timer = setInterval(() => {
                  // 判断超时
                  this.toTopFn(item, index)
                }, 1000)
              }else{
                const time33 = setInterval(() => {
                  if(this.$refs.audioBtn.isOk){
                    clearInterval(time33)
                    this.$refs.audioBtn.onPlay()
                    this.timer = setInterval(() => {
                      // 判断超时
                      this.toTopFn(item, index)
                    }, 1000)
                  }
                }, 300)
              }
            })
          } catch (err) {
            console.log(err)
            Toast('请求下一个音频接口失败')
          }
        }
      },
      playFn222(){
        this.$refs.audioBtn.onPlay()
      },
      toTopFn(item, index){
        item.currentTime = Math.round(this.$refs.audioBtn.$refs.audio.currentTime)
        if(item.currentTime >= item.length ){
          clearInterval(this.timer)
          if(this.playAll && index+1 < this.audioObj.rows){
              this.playFn(this.audioList[index+1], index+1)
          }else{
            item.currentTime = 0
            item.palyIng = false
            this.playAll = false
            this.palyIng = false
          }
        }
      },

      topage(){
        this.$router.push(`/audioAlbum?id=${this.$route.query.id}`)
      },
      lengthFnn(duration) {
        let tTime = duration;
        // let h = Math.floor(tTime/3600);
        let m = Math.floor(tTime%3600/60);
        let s = Math.floor(tTime%60);
        // h = h>10?h:"0"+h
        m = m>=10?m:"0"+m
        s = s>=10?s:"0"+s
        // return h+":"+m+":"+s
        return m+":"+s
      },
      topageDetail(id,view_pass){
        if(!this.canView&&view_pass!=""){
          this.showDialog = true;
          return;
        }
        this.$router.push(`/audioDetail?id=${id}`)
      },
      async getaudioList(flag = false) {
        try {
          
          if(flag){
            this.upLoading = false
          }else{
            Indicator.open()
          }
          this.id = this.$route.query.id || 'faf1460e-743f-4fa5-8c98-8840cdf216b8'
          const res3 = await this.axios.get(`https://api.ayerdudu.com/v1/album/${this.id}`)
          this.albumObj = res3.data.data
          //const res = await this.axios.get(`https://new-videoapi.ayerdudu.com/v1/audio/audios?pageNumber=${this.pageNumber}&pageSize=20&orderField=created_at&sort=asc&albumid=${this.id}`)
          const res = await this.axios.get(`https://api.ayerdudu.com/v1/audio/audios?pageNumber=${this.pageNumber}&pageSize=20&enable=1&orderField=&sort=asc&albumid=${this.id}`)
          this.audioObj = res.data
          if(flag){
            const pushArr = res.data.data
            pushArr.forEach(item => {
              Vue.set(item, 'palyIng', false)
              Vue.set(item, 'currentTime', 0)
              Vue.set(item, 'audioUrl', '')
              Vue.set(item, 'isActive', false)
              if(!item.enable){
                this.audioList.push(item)
              }
            })
            // this.audioList = [...this.audioList, ...pushArr]
            this.upLoading = true
          }else{
            res.data.data.forEach(item => {
              if(!item.enable){
                this.audioList.push(item)
              }
            })
            //this.audioList = res.data.data
            this.audioList.forEach(item => {
              Vue.set(item, 'palyIng', false)
              Vue.set(item, 'currentTime', 0)
              Vue.set(item, 'audioUrl', '')
              Vue.set(item, 'isActive', false)
            })
            this.getAuditMp3(this.audioList[this.index])
          }
          this.canView = this.$checkViewPass("audioList-auth-"+this.id,this.albumObj.view_pass);
          Indicator.close()
          if(!this.audioList.length){
            this.isData = true
          }
        } catch (err) {
          this.isData = true
          Indicator.close()
        }
      },
      handleConfirm(value) {
        if(value==this.albumObj.view_pass){
          localStorage.setItem(`audioList-auth-${this.id}`, value);
          this.showDialog = false
          this.canView = true;
        }else{
          Toast({
            message:'密码不对！',
          });
        }

      },
    }
  }
</script>

<style lang="less" scoped>
.album{
  width: 100%;
  //overflow: hidden;
  //overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .conntent{
    padding: 0 40px;
    height: 104px;
    
  }
}
.video_btnn{
  width: 100%;
  height: 70px;
  margin-top: 20px;
  .video_count{
    float: left;
    font-size: 34px;
    font-weight: bold;
    line-height: 70px;
  }
  .buylink{
    float: right;
    //background-image: linear-gradient(to right, #fe7450 , #f6451b);
    padding: 19px 28px;
    border-radius: 40px;
    color: #f6451b;
    border-color: #f6451b;
    font-size: 24px;
    border: 2px solid #f6451b;
    margin-right: 30px;
    >div{

      >span{
        float: left;
        margin-bottom: -3px;
      }
    }
  }
  .palyall{
    float: right;
    background-image: linear-gradient(to right, #fe7450 , #f6451b);
    padding: 19px 28px;
    border-radius: 40px;
    color: #fff;
    font-size: 22px;
    >div{
      display: flex;
      align-items: center;
      >img{
        float: left;
        width: 20px;
        height: 26px;
        margin-right: 10px;
        margin-top: 3px;
      }
      >span{
        display: inline-block;
      }
    }
  }

  //.palyall{
  //  float: right;
  //  background-image: linear-gradient(to right, #fe7450 , #f6451b);
  //  padding: 19px 28px;
  //  border-radius: 40px;
  //  color: #fff;
  //  font-size: 26px;
  //  >div{
  //    display: inline-flex;          /* 启用 Flex 布局 */
  //    align-items: center;    /* 垂直居中对齐 */
  //    gap: 10px;
  //    >img{
  //      width: 20px;
  //      height: 26px;
  //      vertical-align: middle; /* 关键 */
  //    }
  //    >span{
  //      vertical-align: middle; /* 关键 */
  //    }
  //  }
  //}
}
.video-list{
  min-height: 30px;
  padding: 0 40px 100px;
  .item-audio{
    height: 124px;
    position: relative;
    padding-top: 10px;
    .name{
      font-size: 29px;
      display: block;
      color: #000;
      margin-bottom: 5px;
    }
    .shichang{
      font-size: 22px;
      color: #888888;
     
    }
    .btn{
      position: absolute;
      display: block;
      width: 50px;
      height: 50px;
      overflow: hidden;
      right: 0px;
      top: 23px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    &.active{
      .name{
        color: #f6451b;
      }
      .shichang{
        color: #f6451b;
      }
    }
  }
}
.isData{
  line-height: 100px;
  text-align: center;
  font-size: 30px;
}
</style>
